import { Table, Thead, Tbody, Tfoot, Tr, Th, TableContainer } from '@chakra-ui/react'
import { Row } from './Row'
import { Song } from 'services/openai'

type Props = {
  songs: Song[]
}

export const SongTable = ({ songs }: Props) => {
  return (
    <TableContainer>
      <Table size='sm'>
        <Thead>
          <Tr>
            <Th>Title</Th>
            <Th>Artist</Th>
            <Th>YouTube Link</Th>
          </Tr>
        </Thead>
        <Tbody>
          {songs.map((song, index) => (
            <Row key={`${song.title}-${index}`} song={song} />
          ))}
        </Tbody>
        <Tfoot>
          <Tr>
            <Th>Title</Th>
            <Th>Artist</Th>
            <Th>YouTube Link</Th>
          </Tr>
        </Tfoot>
      </Table>
    </TableContainer>
  )
}
